/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DriverPaginationResponseAllOfDataInner } from './DriverPaginationResponseAllOfDataInner';
import {
    DriverPaginationResponseAllOfDataInnerFromJSON,
    DriverPaginationResponseAllOfDataInnerFromJSONTyped,
    DriverPaginationResponseAllOfDataInnerToJSON,
    DriverPaginationResponseAllOfDataInnerToJSONTyped,
} from './DriverPaginationResponseAllOfDataInner';

/**
 * 
 * @export
 * @interface DriverPaginationResponse
 */
export interface DriverPaginationResponse {
    /**
     * 全体件数
     * @type {number}
     * @memberof DriverPaginationResponse
     */
    totalCount?: number;
    /**
     * 現在のページ番号
     * @type {number}
     * @memberof DriverPaginationResponse
     */
    page?: number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof DriverPaginationResponse
     */
    count?: number;
    /**
     * 総ページ数
     * @type {number}
     * @memberof DriverPaginationResponse
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<DriverPaginationResponseAllOfDataInner>}
     * @memberof DriverPaginationResponse
     */
    data: Array<DriverPaginationResponseAllOfDataInner>;
}

/**
 * Check if a given object implements the DriverPaginationResponse interface.
 */
export function instanceOfDriverPaginationResponse(value: object): value is DriverPaginationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function DriverPaginationResponseFromJSON(json: any): DriverPaginationResponse {
    return DriverPaginationResponseFromJSONTyped(json, false);
}

export function DriverPaginationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverPaginationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'page': json['page'] == null ? undefined : json['page'],
        'count': json['count'] == null ? undefined : json['count'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'data': ((json['data'] as Array<any>).map(DriverPaginationResponseAllOfDataInnerFromJSON)),
    };
}

export function DriverPaginationResponseToJSON(json: any): DriverPaginationResponse {
    return DriverPaginationResponseToJSONTyped(json, false);
}

export function DriverPaginationResponseToJSONTyped(value?: DriverPaginationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'page': value['page'],
        'count': value['count'],
        'totalPages': value['totalPages'],
        'data': ((value['data'] as Array<any>).map(DriverPaginationResponseAllOfDataInnerToJSON)),
    };
}

